var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapIcon = function SvgMapIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1301_15850)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.75 21h-4.637a25 25 0 0 0 2.2-2.227c2.573-2.96 3.937-6.08 3.937-9.023a8.25 8.25 0 1 0-16.5 0c0 2.944 1.36 6.064 3.938 9.023A25 25 0 0 0 9.887 21H5.25a.75.75 0 1 0 0 1.5h13.5a.75.75 0 1 0 0-1.5M12 6.75a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1301_15850"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgMapIcon;